<template>
	<a href="#" class="close-cross" :class="{ green: !!checkmark }">
		<sym-icon class="fi" :name="icon"></sym-icon>
	</a>
</template>

<script setup lang="ts">
import {computed} from "vue";
import SymIcon from "@fd/helpers/SymIcon.vue";

const props = defineProps<{
	checkmark?: boolean
}>();

const icon = computed<string>(() => props.checkmark ? "checkmark-circle-16-full" : "cross-circle-16-full")
</script>

<style>
.close-cross {
	display: inline-block;
	text-align: center;
	width: 18px;
	height: 18px;
	line-height: 18px;
	border-radius: 50%;
	transition: opacity 500ms;

	&:focus-visible {
		outline: none;
	}

	& > .fi {
		transition: color 500ms, opacity 500ms;
	}
}
/* This class must be assigned to the parent panel which is closeable */
.closeable {
}

.close-top-left-corner,
.close-top-right-corner {
	position: absolute;
}

.close-top-left-corner {
	top: -9px;
	left: -9px;
}
.close-top-right-corner {
	top: -9px;
	right: -9px;
}

dialog {
	& .close-top-left-corner {
		top: 7px;
		left: 7px;
	}
	& .close-top-right-corner {
		top: 7px;
		right: 7px;
	}
}

@media (hover: hover) {
	.close-top-left-corner,
	.close-top-right-corner {
		opacity: 0;

		&.close-visible {
			box-shadow: 1px 1px 3px black;
			opacity: 0.5;
		}
	}

	.closeable:hover .close-top-left-corner,
	.closeable:hover .close-top-right-corner {
		opacity: 1;
	}
}
</style>